import { colors } from "../constants/colors";

//---------VALIDATION STYLE-----------//
export const validationStyle = { borderBottom: "2px solid red" };

//---------VALIDATION STYLE-----------//
export const wizardValidationStyles = {
  border: "1px solid rgb(183, 2, 2)",
  borderBottom: "1px solid rgb(183, 2, 2)",
  backgroundColor: "rgba(183, 2, 80, 0.1)",
};

//-------- STYLES FOR MUI COMPONENTS--------//
export const muiComponentsTheme = {
  palette: {
    primary: {
      contrastText: "#FFFFFF",
      dark: "#000000",
      main: colors.primary,
      light: "white",
    },
    secondary: {
      contrastText: "#FFFFFF",
      dark: "#000000",
      main: "#68c8f7",
      light: "white",
    },
  },
  components: {
    MuiPickersInputBase: {
      defaultProps: {
        className: "muiPickersDateInput",
        style: {
          border: 'none',
          borderBottom: `2px solid ${colors.primary}`,
          outline: 'none',
        },
      }, 
    },
    MuiDialogTitle: {
      defaultProps: {
        className: "muiDialogTitle",
        style: {
          marginTop: 0,
          padding: 0,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        container: {
          alignItems: "flex-start"
        },
        paper: {
          minWidth: "40%",
        }
      },
    },
  },
};

//--------FILE UPLOAD STYLES--------//
export const baseStyle = {
  flex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "none",
  backgroundColor: "rgb(241, 241, 241)",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

export const activeStyle = {
  borderColor: colors.primary,
};

export const acceptStyle = {
  borderColor: "#00e676",
};

export const rejectStyle = {
  borderColor: "#ff1744",
};
